
import SupportTickets from "../components/admin/AdminSupport";

export default function AdminSupportTicket() {
  return (
    <div>
      <SupportTickets />
    </div>
  );
}
